<template>
  <div class="sub-navi-wrapper">
    <div v-for="items in menuItems" :key="items.id"
         :id="items.id"
         :class="[passiveMenuClass,items.active ? activeMenuClass : '']">
      <ul>
        <li v-for="subitem in items.subMenu" :key="subitem.id" >
            <a v-bind:href="subitem.url"
               :class="[subitem.active? activeLinkClass : '']">
              <span :style="this.$store.getters.positionLeft">{{ subitem.name }}</span>
            </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubMenu',
  data() {
    return {
      activeMenuClass: 'expand',
      passiveMenuClass: 'container-fluid header-sub',
      activeLinkClass:'active'

    }
  },
  computed: {
    menuItems: function () {
      if (this.$store.getters.mainMenu.length){
        return this.$store.getters.mainMenu.filter(mainMenu => mainMenu.hasSub)
      }

      return [];
    },
  }
}
</script>
